<template>
    <div v-if="limitFiles" class="col-12 px-5">
        <div class="alert alert-danger">Por favor añada un solo archivo</div>
    </div>
    <div class="row mx-5">
        <div class="col-12 col-lg-6">
            <div class="form-group">
                <label class="generalLabel" for="from">Desde</label>
                <DatePicker v-model="from" mode="date" :model-config="modelConfig">
                    <template v-slot="{ togglePopover }">
                        <input @click="togglePopover()" class="form-control bg-white generalInput" readonly
                            v-model="from" />
                        <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate"
                            @click="togglePopover()" />
                    </template>
                </DatePicker>
            </div>
        </div>
        <div class="col-12 col-lg-6">
            <div class="form-group">
                <label class="generalLabel" for="to">Hasta</label>
                <DatePicker v-model="to" mode="date" :model-config="modelConfig">
                    <template v-slot="{ togglePopover }">
                        <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="to" />
                        <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate"
                            @click="togglePopover()" />
                    </template>
                </DatePicker>
            </div>
        </div>
    </div>
    <div id="dropzone_whiteList">
        <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input type="file" multiple name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
                accept=".csv,.xlsx" />

            <label for="fileInput" class="file-label">
                <div v-if="isDragging">Suelta para insertar archivo</div>
                <div v-else>Arrastre el archivo aqui o <u>haz click aqui</u> para añadir.</div>
            </label>
            <div class="d-flex justify-content-center preview-container mt-4" v-if="files.length">
                <div v-for="file in files" :key="file.name" class="preview-card">
                    <div class="position-relative">
                        <button type="button" class="close" @click="remove(files.indexOf(file))" aria-label="Delete">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <v-icon name="bi-filetype-csv" scale="3.5" />
                        <p class="fileName">
                            {{ file.name }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3 pt-3 pl-0">
        <div class="col-12">
            <button class="btn generalSecondaryButton float-left" data-dismiss="modal">Cerrar</button>
            <button class="btn btn-primary generalPrimaryButton float-right" @click="uploadFiles()"
                :disabled="to == '' || from == '' || files.length < 1">Enviar</button>
        </div>
    </div>
    <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
        :message="errorMessage" :code="errorCode" />
    <ModalSuccess :id="'modalSuccess'" :modalTitle="'SE HA ENVIADO CORRECTAMENTE'" :class="'modal'" :showFooter="false" />
</template>

<script>
import axios from 'axios';
import { DatePicker } from 'v-calendar';
import ModalError from '../../../Shared/ModalError.vue';
import ModalSuccess from '../../../Shared/ModalSuccess.vue';
import { Modal as ModalBootstrap } from "bootstrap";

export default {
    data() {
        return {
            isDragging: false,
            files: [],
            limitFiles: false,
            to: '',
            from: '',
            modelConfig: {
                type: 'string',
                mask: 'DD/MM/YYYY',
            },
        };
    },
    components: {
        ModalError,
        ModalSuccess,
        DatePicker
    },
    methods: {
        onChange() {
            this.files = [...this.$refs.file.files];
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            console.log(e.dataTransfer.files.length)
            if (e.dataTransfer.files.length < 2) {
                this.$refs.file.files = e.dataTransfer.files;
                this.onChange();
                this.limitFiles = false
            } else {
                this.limitFiles = true;
            }
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        uploadFiles() {
            const files = this.files;
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("file", file);
            });
            formData.append('activeFrom', this.$dateFrontToBack(this.from));
            formData.append('activeTo', this.$dateFrontToBack(this.to));
            formData.append('backOfficeUser', this.$cookies.get('username'));
            formData.append('requester', this.$cookies.get('username'));
            formData.append('uploadDate', new Date().toISOString().split('T')[0]);
            axios.post('/customer/leads/csv-upload', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                console.log(response)
                var myModal = new ModalBootstrap(document.getElementById('modalSuccess'))
                myModal.show()
            }).catch((error) => {
                this.errorCode = error.response.data.code
                this.errorMessage = error.response.data.message
                var myModal = new ModalBootstrap(document.getElementById('modalError'))
                myModal.show()
            });
        },
    },
};
</script>
<style lang="scss">
#dropzone_whiteList {
    display: flex;
    flex-grow: 1;
    align-items: center;
    height: 30vh;
    justify-content: center;
    text-align: center;
}

.dropzone-container {
    padding: 3rem;
    width: 45rem;
    max-height: 30vh;
    background: #f7fafc;
    border: 1px solid #e2e8f0;
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}

.preview-card {
    display: flex;
    padding: 5px;
    margin-left: 5px;
}

.preview-container {
    .close {
        font-size: 2.5rem;
        line-height: 0.4;
        font-weight: normal;
        position: absolute;
        top: 0;
        right: -12px;
    }

    .fileName {
        max-width: 100px;
        max-height: 45px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>